import script from "./TrustBand.vue?vue&type=script&setup=true&lang=js"
export * from "./TrustBand.vue?vue&type=script&setup=true&lang=js"

import "./TrustBand.vue?vue&type=style&index=0&id=73019ad8&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-73019ad8"]])

export default __exports__